import {
  Button,
  Form,
  Row,
  Col,
  Alert,
  Tabs,
  Tab,
  Card,
} from "react-bootstrap";
import { AddServicesPracTeam } from "./AddServicesPracTeam";
import { AddServicesPricing } from "./AddServicesPricing";
import { AddServicesSettings } from "./AddServicesSettings";
import { useEffect, useState, useCallback } from "react";
import {
  getUserPracticeById,
  updateService,
  getUsersByPracticeNumber,
  getServiceById,
} from "../../api";
import { FaUpload } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import React from "react";
import "../../custom.scss";

export function EditServices(props) {
  const { onServiceUpdate, onHide, inline = false, serviceId } = props;
 const [isLoaded, setIsLoaded] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedPractices, setSelectedPractices] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [availablePractices, setAvailablePractices] = useState([]);
  const [uniqueTeamMember, setUniqueTeamMember] = useState([]);
  const [validatePricingFunction, setValidatePricingFunction] = useState(
    () => () => true
  );
  const [pracName, setPracName] = useState([]);

  const [service, setService] = useState({
    servicesName: "",
    servicesDescription: "",
    servicesCost: "",
    servicesDuration: "",
    servicesPractice: [],
    servicesUser: [],
    settings: {
      visible: true,
      websitePrice: "",
      bookable: false,
      upfrontPayable: false,
    },
    pricing: {
      flatRate: "",
      invoiceDescription: "",
      cashDiscountPercentage: "",
      upfrontDiscountPercentage: "",
      specialOfferPercentage: "",
      specialOfferExpiry: "",
      tariffCodeDescription: "",
      paymentOptions: {
        useFlatRate: true, // ✅ FIX: Default to true to match your data
        useFlatAndMedicalAidRate: false,
      },
      selectedTariffs: [],
      selectedNappi: [],
    },
  });

  // ✅ FIX: Use useCallback to prevent infinite re-renders
  const loadServiceDetails = useCallback(async () => {
    try {
      if (!serviceId) return;

      // Load practices & team for logged-in user
      const token = sessionStorage.getItem("user");
      if (token) {
        const decoded = jwtDecode(token);
        const loggedInUserPractices = await getUserPracticeById(decoded._id);

        // ✅ FIX: Add discipline code to prevent missing data
        const pracs = (loggedInUserPractices || []).map((practice) => ({
          practiceNumber: practice.practiceNumber,
          practiceName: practice.practiceName,
          practiceDisciplineCode: practice.practiceDisciplineCode, // Add this
        }));
        
        // ✅ FIX: Remove duplicates to prevent key conflicts
        const uniquePracs = Array.from(
          new Map(pracs.map(p => [p.practiceNumber, p])).values()
        );
        
        setAvailablePractices(uniquePracs);
        setPracName(uniquePracs);

        const teamMemberPromises = uniquePracs.map((p) =>
          getUsersByPracticeNumber(p.practiceNumber)
        );
        const teamMembers = (await Promise.all(teamMemberPromises)).flat();
        const uniqueTeamMembers = Array.from(
          new Map(teamMembers.map((m) => [m._id, m])).values()
        );
        setUniqueTeamMember(uniqueTeamMembers);
      }

      // Fetch the service
      const serviceData = await getServiceById(serviceId);
      if (!serviceData) return;
      
      console.log('Loaded service data:', serviceData);
      console.log('Service pricing:', serviceData.pricing);

      // ✅ FIX: More robust data loading with better fallbacks
      setService({
        servicesName: serviceData.servicesName || "",
        servicesDescription: serviceData.servicesDescription || "",
        servicesCost: serviceData.servicesCost || "",
        servicesDuration: serviceData.servicesDuration || "",
        servicesPractice: Array.isArray(serviceData.servicesPractice) 
          ? serviceData.servicesPractice 
          : [],
        servicesUser: Array.isArray(serviceData.servicesUser) 
          ? serviceData.servicesUser 
          : [],
        settings: {
          visible: serviceData.settings?.visible ?? true,
          websitePrice: serviceData.settings?.websitePrice ?? "",
          bookable: serviceData.settings?.bookable ?? false,
          upfrontPayable: serviceData.settings?.upfrontPayable ?? false,
        },
        pricing: {
          flatRate: serviceData.pricing?.flatRate || "",
          invoiceDescription: serviceData.pricing?.invoiceDescription || "",
          cashDiscountPercentage: serviceData.pricing?.cashDiscountPercentage || "",
          upfrontDiscountPercentage: serviceData.pricing?.upfrontDiscountPercentage || "",
          specialOfferPercentage: serviceData.pricing?.specialOfferPercentage || "",
          specialOfferExpiry: serviceData.pricing?.specialOfferExpiry || "",
          tariffCodeDescription: serviceData.pricing?.tariffCodeDescription || "",
          paymentOptions: {
            useFlatRate: serviceData.pricing?.paymentOptions?.useFlatRate ?? true,
            useFlatAndMedicalAidRate: serviceData.pricing?.paymentOptions?.useFlatAndMedicalAidRate ?? false,
          },
          selectedTariffs: Array.isArray(serviceData.pricing?.selectedTariffs) 
            ? serviceData.pricing.selectedTariffs 
            : [],
          selectedNappi: Array.isArray(serviceData.pricing?.selectedNappi)
            ? serviceData.pricing.selectedNappi
            : Array.isArray(serviceData.pricing?.selectedNappis)
            ? serviceData.pricing.selectedNappis
            : [],
        },
      });

      // ✅ FIX: Ensure these are arrays
      setSelectedPractices(Array.isArray(serviceData.servicesPractice) 
        ? serviceData.servicesPractice 
        : []);
      setSelectedUsers(Array.isArray(serviceData.servicesUser) 
        ? serviceData.servicesUser 
        : []);
        
    } catch (e) {
      console.error("Failed to load service details:", e);
    } finally {
      setIsLoaded(true);
    }
  }, [serviceId]); // Only depend on serviceId

  useEffect(() => {
    loadServiceDetails();
  }, [loadServiceDetails]);

  const handleSettingsChange = useCallback((updatedSettings) => {
    setService((prev) => ({ ...prev, settings: updatedSettings }));
  }, []);

  const handlePricingChange = useCallback((updatedPricing) => {
    console.log('Pricing change received:', updatedPricing); // Debug log
    setService((prev) => ({ ...prev, pricing: updatedPricing }));
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!service.servicesName)
      newErrors.servicesName = "Service name is required.";
    if (!service.servicesDescription)
      newErrors.servicesDescription = "Service description is required.";
    if (
      !service.servicesDuration ||
      !/^\d{2}:\d{2}$/.test(service.servicesDuration)
    ) {
      newErrors.servicesDuration = "Enter duration in HH:mm format.";
    }
    if (!selectedPractices.length)
      newErrors.servicesPractice = "At least one practice must be selected.";
    if (!selectedUsers.length)
      newErrors.servicesUser = "At least one user must be selected.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isPricingValid = validatePricingFunction();
    if (!validateForm() || !isPricingValid) return;

    try {
      const response = await updateService(serviceId, {
        ...service,
        servicesDuration: service.servicesDuration,
        servicesPractice: selectedPractices,
        servicesUser: selectedUsers,
      });

      if (response.status === 200) {
        setSuccessAlert(true);
        setTimeout(() => {
          setSuccessAlert(false);
          onServiceUpdate?.();
          onHide?.();
        }, 900);
      }
    } catch (error) {
      console.error("Error updating service:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "servicesCost") {
      const sanitized = value.replace(/[^0-9.,]/g, "");
      const parts = sanitized.split(",");
      let formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      if (parts.length > 1) formatted += `,${parts[1].slice(0, 2)}`;
      setService((prev) => ({ ...prev, [name]: `R ${formatted}` }));
    } else if (name === "servicesDuration") {
      const input = value.replace(/[^0-9]/g, "");
      let formatted =
        input.length > 2 ? `${input.slice(0, 2)}:${input.slice(2, 4)}` : input;
      if (formatted.length > 5) formatted = formatted.slice(0, 5);
      setService((prev) => ({ ...prev, [name]: formatted }));
    } else {
      setService((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handlePracticeChange = useCallback((practiceNumber) => {
    setSelectedPractices((prev) =>
      prev.includes(practiceNumber)
        ? prev.filter((p) => p !== practiceNumber)
        : [...prev, practiceNumber]
    );
  }, []);

  const handleUserChange = useCallback((userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((u) => u !== userId)
        : [...prev, userId]
    );
  }, []);

  if (inline) {
    return (
      <Card className="border-0">
        <Card.Body className="pt-2">
          {successAlert && (
            <Alert variant="success" className="w-100 fs-6 fw-normal py-2">
              Service updated successfully!
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="servicesName">
                <Form.Label>Service Name</Form.Label>
                <Form.Control
                  name="servicesName"
                  value={service.servicesName}
                  isInvalid={!!errors.servicesName}
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.servicesName}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="servicesDescription">
                <Form.Label>Service Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="servicesDescription"
                  value={service.servicesDescription}
                  isInvalid={!!errors.servicesDescription}
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.servicesDescription}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Col md={2}>
                <Form.Group as={Col} controlId="servicesDuration">
                  <Form.Label>Service Duration</Form.Label>
                  <Form.Control
                    name="servicesDuration"
                    value={service.servicesDuration}
                    isInvalid={!!errors.servicesDuration}
                    onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.servicesDuration}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <hr />
            <h6 className="text-primary">Service Settings</h6>
            <Tabs
              defaultActiveKey="practice"
              id="service-tabs"
              className="mb-3"
              justify
            >
              <Tab eventKey="practice" title="Practice & Team">
                <AddServicesPracTeam
                  key={`${serviceId}+2`}
                  pracName={availablePractices}
                  selectedPractices={selectedPractices}
                  uniqueTeamMember={uniqueTeamMember}
                  selectedTeamMembers={selectedUsers}
                  handlePracticeChange={handlePracticeChange}
                  handleTeamMemberChange={handleUserChange}
                  errors={errors}
                />
              </Tab>

              <Tab eventKey="billing" title="Billing Settings">
                <AddServicesPricing
                key={serviceId} 
                  onPricingChange={handlePricingChange}
                  servicePricing={service.pricing}
                  selectedPractices={selectedPractices}
                  pracName={pracName}
                  onValidate={(validateFn) => setValidatePricingFunction(() => validateFn)}
                />
              </Tab>

              <Tab eventKey="settings" title="General Settings">
                <AddServicesSettings
                  key={`${serviceId}+1`}
                  onSettingsChange={handleSettingsChange}
                  serviceSettings={service.settings}
                />
              </Tab>
            </Tabs>

            <div className="d-flex gap-2 mt-3">
              <Button variant="primary" className="px-4" type="submit">
                <FaUpload className="me-2" />
                Submit
              </Button>
              <Button
                variant="outline-secondary"
                className="px-4"
                type="button"
                onClick={() => onHide?.()}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    );
  }
}